import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

// Constants

// Acessors

const initialState = {};

export const changeStudyStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const updateStudyStatus =
  (statusId, studyEnrollmentID, dailyTarget, reason) =>
  async (dispatch, getState) => {
    let body = {
      studyEnrollmentID: studyEnrollmentID,
      statusToUpdate: statusId,
      reasonForChange: reason,
    };

    if (dailyTarget) {
      body.dailyTarget = dailyTarget;
    }

    return axios
      .put(`/api/study/enroll/status`, body)
      .then(() => {
        return Promise.resolve("Study status updated successfully!");
      })
      .catch((error) => {
        const defaultMessage = error.response?.data
          ? error.response.data
          : "There was an error while trying to update the study status!";

        return handleHttpErrors(error.request?.status, {
          default: defaultMessage,
        });
      });
  };

export const mapDispatchToProps = {
  updateStudyStatus,
};
